import * as React from 'react';
import { cn } from '../../lib/cn';

export interface TopbarProps extends React.HTMLAttributes<HTMLDivElement> {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}

export function Topbar({ left, center, right, className, ...props }: TopbarProps) {
  return (
    <div className={cn('flex h-14 min-h-14 min-w-0 items-center gap-2 px-3 sm:gap-3 sm:px-4', className)} {...props}>
      <div className="flex min-w-0 shrink-0 items-center gap-2">{left}</div>
      <div className="flex min-w-0 flex-1 justify-center px-0.5 sm:px-1">{center}</div>
      <div className="flex min-w-0 shrink items-center justify-end gap-1.5 sm:gap-2">{right}</div>
    </div>
  );
}
